export default __webpack_public_path__ + "static/media/logout.77483c28.svg";